import { Box } from '@mui/material';
import React from 'react';
import BaseVideo from 'components/video/BaseVideo';
import { useMediaQuery } from '@mui/system';
import appTheme from 'ui-blocks/AppTheme';
import { ASSETS } from 'constants/Constants';
import { createImagineStyles } from '../createImagineStyles';

export default function CreateImagineVideos() {
	const isMobile = useMediaQuery(appTheme.breakpoints.down('smTab'));
	return (
		<Box sx={{ position: 'relative', width: { xs: '100%', mobileUi: '75%', xxl: '65%' } }}>
			<Box id="create-imagine-video-container" sx={[createImagineStyles.videoContainer]}>
				{ASSETS.characterSectionVideos.map((video, index) => (
					<Box key={`hero-video-${video.id}`} sx={{ flex: 1 }}>
						<BaseVideo
							id={`hero-video-${index}`}
							src={video.src}
							poster={video.thumbnail}
							controls={false}
							autoPlay
							muted
							loop
							playPauseIcon={false}
							showSkeletonLoading
							playsInline
							style={{
								...createImagineStyles.baseVideo,
								borderRadius: isMobile ? '16px' : '32px',
							}}
							containerStyle={{
								aspectRatio: '0.55',
							}}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
}
